/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { Badge, BadgeProps } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { DateTime } from 'luxon'
import { fetchAgendaEventsCount } from '../../lib/rest/agendaAPIClient'

function AgendaEventsCountBadge (props: BadgeProps) {
  const startDate = useMemo(() => DateTime.local().startOf('day').toISO(), [])
  const endDate = useMemo(() => DateTime.local().startOf('day').toISO(), [])

  const query = useQuery({
    queryKey: ['agendaEventsCount', startDate, endDate],
    queryFn: () => fetchAgendaEventsCount({ startDate, endDate }),
    refetchInterval: 1000 * 60 * 10
  })
  const count = query.data?.count

  return (
    <Badge
      variant="outline"
      {...props}
      color={count > 0 ? 'orange' : 'gray'}
    >
      {count}
    </Badge>
  )
}

export default AgendaEventsCountBadge
